import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: ['./input-textarea.component.scss'],
    standalone: false
})
export class InputTextareaComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() placeholder;
  @Input() label;
  @Input() control;
  @Input() tooltip;
  @Input() hideInput;
  @Input() initialHeight = '150px';
  public showHiddenInput: boolean = false;
  // probably make the errorMessages modular
  public errorMessages = {
    urlInvalid: 'Url is invalid.',
    required: 'Required.',
    noWhitespace: 'No whitespace.',
    duplicateName: 'Must be a unique name.',
    invalidProviderName:
      'Must have no whitespace or unscores and be more than 5 characters',
  };
  public control$;
  public form$;
  public isRequired: boolean = false;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.control?.validator) {
      this.isRequired = this.control.validator(
        new UntypedFormControl()
      )?.required;
    }
    this.control$ = this?.control?.statusChanges.pipe(
      tap(() => {
        this.cdr?.detectChanges();
      })
    );
  }

  get isDisabled(): boolean {
    return !!this.disabled || !!this.control?.disabled;
  }

  get error() {
    if (
      !this.control?.errors ||
      !Object.keys(this?.control?.errors || {}).length
    )
      return null;

    const isControlInteracted = this?.control?.dirty || this?.control?.touched;
    if (!isControlInteracted) return null;
    const firstErrorKey = Object.keys(this?.control?.errors).find(
      key => this?.control?.errors?.[key]
    );

    return firstErrorKey || null;
  }
}
